export default {
    filters: {
        title: "Filter",
        removeFilter: "Ta bort filter",
        filterIntensity: "Filterintensitet",
        duotone: {
            title: "Duoton",
            desert: "Öken",
            peach: "Persika",
            clash: "Krock",
            plum: "Plommon",
            breezy: "Svalkande",
            deepBlue: "Djupt Blått",
            frog: "Groda",
            sunset: "Solnedgång",
        },
        blackAndWhite: {
            title: "Svartvitt",
            ad: "1920 E.Kr",
            greyed: "Gråtonad",
            dusty: "Dammig",
            litho: "Litografi",
            sepia: "Sepia",
            weathered: "Förvittrad",
            hardStuff: "Svårigheter",
        },
        vintage: {
            title: "Vintage",
            polaroid: "Polaroid",
            sunny: "Soliga 70-talet",
            oldTimer: "Veteranbil",
            inferno: "Inferno",
            snappy: "Snappy",
        },
        smooth: {
            title: "Jämn eller slät",
            chestnut: "Brunuggla",
            softy: "Mjukis",
            pebble: "Småsten",
            moss: "Mossa",
            lemon: "Citron",
            greenGap: "Grön Klyfta",
        },
        cold: {
            title: "Kall",
            colla: "Klistra",
            solanus: "Solanus",
            kalmen: "Kalmen",
            jorah: "Joran",
            levante: "Levante",
            zephyr: "Zephyr",
        },
        warm: {
            title: "Varm",
            golden: "Guldfärgad",
            lowFire: "Låg Eld",
            sunrise: "Soluppgång",
            flatBack: "Platt Rygg",
            pumpkin: "Pumpa",
        },
    },
};
